export enum ReturnLineType {
    Normal = "Normal",
    Canceled = "Canceled",
    Deleted = "Deleted",
}
